export default __webpack_public_path__ + "static/cafe_36005-45bccc5f90487dc11a07cbf5f0b10694.png";